export default function getManifestFromCookie() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return null;
  }

  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('cs-personalize-manifest='));

  if (!cookie) return null;

  try {
    const raw = decodeURIComponent(cookie.split('=')[1]);
    return JSON.parse(raw);
  } catch (err) {
    console.error('Failed to parse cs-personalize-manifest:', err);
    return null;
  }
}
